import React from 'react'
import { useSelector } from 'react-redux'

import GridElementContainer from '../../GridElementContainer'
import Icon from 'components/UI/Icon'
import UpcomingClassLanguage from '../../../../../../pages/common/Statistic/UpcomingClassLanguage'
import Avatar from '../../../../../UI/Avatar'

import { useUserName } from '../../../../../../hooks'

import { selectUserData } from '../../../../../../routing/fetchingfunction/user/user.reducer'

import { arrayFromNumber, getAvatarUrl } from '../../../../../../helpers'

const MyProfileTutor = ({ containerClassName = '', className = '' }) => {
  const userData = useSelector(selectUserData)

  const userName = useUserName()

  // Handle the case when userData is null
  if (!userData || !userData.profile) {
    return (
      <GridElementContainer className={containerClassName} title="My Profile">
        <div
          className={`relative p-[10px] rounded-md !border border-primary-450 w-full flex flex-col items-center justify-between h-full ${className}`}
        >
          <div className="w-12 h-12 !mb-3">
            <Avatar src={null} gender="neutral" className="w-full h-full block" />
          </div>
          <p className="text-center text-primary-100 font-semibold !mb-0">Loading profile...</p>
        </div>
      </GridElementContainer>
    )
  }

  // Safely get languages with fallback to empty array
  const userLanguagesContent = (userData.profile.languages || []).map((language) => {
    return <UpcomingClassLanguage key={language} language={language} />
  })

  const starsContent = arrayFromNumber(6).map((star) => {
    return <Icon key={`check-${star}`} name="sun-check" className="w-[24px] h-[24px]" />
  })

  return (
    <GridElementContainer className={containerClassName} title="My Profile">
      <div
        className={`relative p-[10px] rounded-md !border border-primary-450 w-full flex flex-col items-center justify-between h-full ${className}`}
      >
        {/*<span className="absolute left-[10px] top-[10px] bg-primary-500 !border border-[#F9E0CD] rounded-[4px] text-primary-100 !py-1 !px-2">*/}
        {/*  Tutor*/}
        {/*</span>*/}

        <span className="absolute right-[10px] top-[10px] !border border-primary-75 py-[2px] !px-2 rounded-lg text-primary-100 text-xs font-bold bg-primary-200">
          <span className="text-[#B733DD]">ROI</span> 36%
        </span>

        <div className="w-12 h-12 !mb-3">
          <Avatar
            src={getAvatarUrl(userData?.user_tutor_profile?.profile_picture)}
            gender={userData?.profile?.gender}
            className="w-full h-full block"
          />
        </div>

        {userData?.user_tutor_profile && (
          <h3 className="text-primary-100 text-sm font-bold mb-3 text-center">{userName}</h3>
        )}

        <div className="flex items-center justify-center gap-x-[2px] mb-3">{starsContent}</div>

        <div className="flex items-center justify-center gap-x-[10px] mb-3">
          <div className="flex items-center justify-center">
            <Icon className="mr-[6px]" name="global-line" color="#F79009" />

            <img className="block" src="/assets/image/America_Flag.svg" alt="us" />
          </div>

          <div className="flex items-center justify-center">
            <Icon className="mr-[6px]" name="home" color="#F79009" />

            <img className="block" src="/assets/image/Canada_Flag.svg" alt="us" />
          </div>
        </div>

        {!!userData?.profile?.languages?.length && (
          <div className="flex items-center justify-center">
            <div className="mr-[9px]">
              <img className="block" src="/assets/icon/fontOrangeIcon.png" alt="language" />
            </div>

            <ul className="flex items-center flex-wrap gap-x-[4px]">{userLanguagesContent}</ul>
          </div>
        )}
      </div>
    </GridElementContainer>
  )
}

export default MyProfileTutor
